import React from 'react';
import ReviewSpinner from '../ReviewSpinner';

/**
 * Wraps a component that receives `review` and `reviewContext` props and only renders it once both have loaded.
 * The `reviewMeta` prop is also consumed but not passed to the wrapped component.
 *
 * @param WrappedComponent component that receives `review` and `reviewContext`.
 */
const requiresReview = (WrappedComponent) => {
  return ({ review, reviewContext, reviewMeta, ...props }) => {
    if (!reviewMeta) {
      throw 'reviewMeta prop is missing';
    }

    if (!reviewContext) {
      throw 'reviewContext prop is missing';
    }

    const loading = !reviewMeta.ready || !reviewContext.ready;

    if (loading) {
      return <ReviewSpinner/>;
    } else {
      if (reviewMeta.error) {
        return <div className="alert alert-danger">
          {reviewMeta.errorMessage || 'Error loading review'}
        </div>;
      } else {
        return <WrappedComponent review={review} reviewContext={reviewContext} {...props}/>;
      }
    }
  };
};

export default requiresReview;
